import { render, staticRenderFns } from "./FundForm.vue?vue&type=template&id=1d6d1ef9&scoped=true&"
import script from "./FundForm.vue?vue&type=script&lang=js&"
export * from "./FundForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6d1ef9",
  null
  
)

export default component.exports